import type { JobCostOverviewDto } from '../types/jobCostOverview';
import type { ChargeOverviewLineItemDto, PaymentOverviewLineItemDto } from '../types/jobCostOverview';
import { ContractsPanel } from './ContractsPanel';
import { PaymentsPanel } from './PaymentsPanel';
import { CustomerSummaryPanel } from './CustomerSummaryPanel';
import { SubcontractorPanel } from './SubcontractorPanel';
import { PayrollPanel } from './PayrollPanel';
import { EstimatorInfoPanel } from './EstimatorInfoPanel';

interface CostOverviewSidebarProps {
  jobId: number;
  data: JobCostOverviewDto;
  onAddCharge: () => void;
  onEditCharge: (charge: ChargeOverviewLineItemDto) => void;
  onAddPayment: () => void;
  onEditPayment: (payment: PaymentOverviewLineItemDto) => void;
}

export function CostOverviewSidebar({
  jobId,
  data,
  onAddCharge,
  onEditCharge,
  onAddPayment,
  onEditPayment,
}: CostOverviewSidebarProps) {
  const subCommission = data.commissions?.find((c) => c.commissionType === 'Subcontractor');
  const payrollCommission = data.commissions?.find((c) => c.commissionType === 'Payroll');
  const estimatorCommission = data.commissions?.find((c) => c.commissionType === 'Estimator');

  return (
    <div className="space-y-2">
      <ContractsPanel
        jobId={jobId}
        charges={data.charges}
        chargeTotal={data.chargeTotal}
        onAddCharge={onAddCharge}
        onEditCharge={onEditCharge}
      />

      <PaymentsPanel
        jobId={jobId}
        payments={data.payments}
        paymentTotal={data.paymentTotal}
        onAddPayment={onAddPayment}
        onEditPayment={onEditPayment}
      />

      <CustomerSummaryPanel summary={data.customerSummary} />

      {subCommission && <SubcontractorPanel commission={subCommission} />}
      {payrollCommission && <PayrollPanel commission={payrollCommission} />}
      {estimatorCommission && <EstimatorInfoPanel commission={estimatorCommission} />}
    </div>
  );
}
